import { setQueryParams } from './setQueryParams'

/**
 * Returns a product page url with size guides open, based on product type.
 *
 * @param handle - The handle of the product. It's a code for the product. It's format is lowercase and with hyphens.
 */
export const getSizeGuideUrl = (handle?: string): string | null => {
  if (!handle) {
    return null
  }

  return setQueryParams(`/products/${handle}`, [
    { name: 'size-guide', value: 'true' },
  ])
}
